import { initialAccountState } from './initState/initAccountState';
import { RequestState } from '@shared/constants/request';
import { UserRoleTypes } from '@shared/constants/UserRoleTypes';
import * as PhoneVerificationActions from '@shared/redux/actions/phoneVerification-actions';
import {
  ACCOUNT_DETAILS_REQUEST,
  ACCOUNT_DETAILS_REQUEST_FAILED,
  ACCOUNT_DETAILS_REQUEST_SUCCESS,
  UsersActions,
} from '@shared/redux/actions/users-actions';
import { AccountState } from '@shared/redux/state/account';
import enumExtensions from '@shared/util/enum';

export default function account(
  state: AccountState = initialAccountState,
  action: UsersActions | PhoneVerificationActions.PhoneVerificationActions,
): AccountState {
  switch (action.type) {
    case ACCOUNT_DETAILS_REQUEST:
      return {
        ...state,
        requestState: RequestState.PENDING,
      };

    case ACCOUNT_DETAILS_REQUEST_SUCCESS:
      return {
        ...state,
        details: action.payload,
        isOrganisationManager: enumExtensions.hasFlag(action.payload.userRoles, UserRoleTypes.OrganisationManager),
        requestState: RequestState.SUCCESS,
      };

    case ACCOUNT_DETAILS_REQUEST_FAILED:
      return {
        ...state,
        details: null,
        error: action.payload,
        requestState: RequestState.FAILED,
      };
    case PhoneVerificationActions.VERIFY_CODE_SUCCESS:
      if (state.requestState === RequestState.SUCCESS) {
        return {
          ...state,
          details: {
            ...state.details,
            phoneNumberConfirmed: true,
          },
        };
      }

    default:
      return state;
  }
}
